// extracted by mini-css-extract-plugin
export var numpadContainer = "_ph-1";
export var phoneButton = "_ph-0";